import styled from 'styled-components';

export const StepBadgesRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const StepIndicatorBadge = styled.div`
  width: fit-content;
  max-width: 70px;
  min-height: 24px;
  padding: 2px 12px;
  border-radius: 100px;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
  transition: all 0.2s ease;

  border: 1px solid #d6d6d6;
  background: transparent;
  color: #858585;

  cursor: pointer;

  &:hover {
    border-color: #5b68df;
    color: #5b68df;
  }

  &.is-answered {
    background: #5b68df;
    border-color: #5b68df;
    color: #fff;
  }

  &.is-active {
    border-color: #5b68df;
    box-shadow: 0 0 0 2px rgba(91, 104, 223, 0.3);
  }

  &.is-correct {
    background: #10b981;
    border-color: #10b981;
    color: #fff;
    min-width: 75px;
  }

  &.is-incorrect {
    background: #ef4444;
    border-color: #ef4444;
    color: #fff;
    min-width: 75px;
  }

  @media (max-width: 768px) {
    min-width: 55px;
    font-size: 12px;
    padding: 2px 8px;
  }
`;

export const StepIndicatorBadgeDecision = styled(StepIndicatorBadge)`
  min-width: 86px !important;
  max-width: 125px !important;

  border-radius: 8px;
  border: 1px solid #d6d6d6;
  background: transparent;
  color: #101010;

  &.is-active {
    background: #5b68df;
    border-color: #5b68df;
    box-shadow: 0 0 0 0 rgba(91, 104, 223, 0.3);
    color: #fff;
  }

  &.is-answered {
    background: transparent;
    border-color: #d6d6d6;
    color: #101010;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const ProgressHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #858585;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13px;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 999px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ widthPercent: number }>`
  height: 100%;
  width: ${(props) => `${props.widthPercent}%`};
  background: linear-gradient(90deg, #5768ff 0%, #8190ff 100%);
  border-radius: inherit;
  transition: width 0.2s ease;
`;
